import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.to-string.js";
import { DEFAULT_OTHER_NODE } from "../shared/other-node";
export var getDefaultOtherNodeOrUndefined = function getDefaultOtherNodeOrUndefined(nodesInLevelThatWillBeRendered, strictLocalize) {
  var otherNode = DEFAULT_OTHER_NODE(strictLocalize);
  var shouldRenderDefaultOtherNode = nodesInLevelThatWillBeRendered.every(function (node) {
    return node.label !== otherNode.label;
  });
  return shouldRenderDefaultOtherNode ? otherNode : undefined;
};